import { ApplicationConfig, APP_INITIALIZER, ErrorHandler, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideKeycloak } from 'keycloak-angular';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';

import { routes } from './app.routes';
import { environment } from '@env/environment';
import { authInterceptor } from './core/http/auth.interceptor';
import { apiConnectionInterceptor } from './core/http/api-connection.interceptor';
import { httpRequestTelemetryInterceptor } from './core/http/http-request-telemetry.interceptor';
import { DATE_PROVIDERS } from '@shared/config/date.config';
import { CURRENCY_PROVIDERS } from '@shared/config/currency.config';
import { PAGINATOR_PROVIDER } from '@shared/config/paginator.config';
import { provideApiClients } from './core/api/provide-api-clients';
import { IconRegistryService } from './core/services/icon-registry.service';
import { FrontendRouteObservabilityService } from './core/observability/frontend-route-observability.service';
import { VerboseErrorHandler } from './core/observability/verbose-error.handler';


// Registrar el locale español (Argentina)
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    {
      provide: ErrorHandler,
      useClass: VerboseErrorHandler,
    },
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideRouter(routes),
    ...DATE_PROVIDERS,
    CURRENCY_PROVIDERS,
    PAGINATOR_PROVIDER,
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { showDelay: 1000 }
    },
    provideHttpClient(
      withInterceptors([httpRequestTelemetryInterceptor, apiConnectionInterceptor, authInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
      })
    ),
    // NSwag-generated API clients (agregar nuevos clientes en provide-api-clients.ts)
    provideApiClients(environment.apiUrl.replace(/\/api$/, '')),
    {
      provide: APP_INITIALIZER,
      useFactory: (iconRegistry: IconRegistryService) => () => iconRegistry,
      deps: [IconRegistryService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (observability: FrontendRouteObservabilityService) => () => observability,
      deps: [FrontendRouteObservabilityService],
      multi: true
    },
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },
      initOptions: {
        onLoad: 'check-sso',
        responseMode: 'query',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
        silentCheckSsoFallback: false
      },
      providers: []
    })
  ]
};
